import { Layout } from "../components"

export default function Example() {
  return (
    <Layout>
      <div className="mx-auto max-w-7xl">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8 sm:pt-32">
          <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
            <div>
              <h1 className="mt-4 text-4xl tracking-tight font-extrabold text-white sm:mt-5 sm:leading-none lg:mt-6 lg:text-5xl xl:text-6xl">
                <span className="md:block">Untuk kebutuhan and</span>{' '}
                <span className="text-blue-400 md:block">silahkan hubungi kami</span>
              </h1>
            </div>
          </div>
          <div className="mt-16 sm:mt-24 lg:mt-0 lg:col-span-6">
            <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden">
              <div className="px-4 py-8 sm:px-10">
                <div>
                  <p className="text-sm font-medium text-gray-700">Konsultasi, Training dan Pembelian Produk </p>
                </div>
                <div className="w-full mt-4 border-t border-gray-300" />
                <div className="mt-6">
                  <p className="text-xs text-gray-500 sm:text-base">
                    Lippo St. Moritz Office Tower, Floor 9, Unit 901.<br/> Jl. Puri Raya Blok U1, Puri Indah, Jakarta Barat 11610
                  </p>
                  <p className="text-xs text-gray-500 sm:text-base">
                    Telp: 021-5860534
                  </p>
                  <p className="text-xs text-gray-500 sm:text-base">
                    HP / WA :<a href="https://wa.me/6281310165341" className="text-blue-500 underline">081310165341</a>
                  </p>
                  <p className="text-xs text-gray-500 sm:text-base">
                    Email : <a href="mailto:cvjayasederhana@gmail.com" className="text-blue-500 underline">cvjayasederhana@gmail.com</a>
                  </p>
                </div>
              </div>
              <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
                <p className="text-xs leading-5 text-center text-gray-500">
                  Tim kami akan menghubungi anda secepatnya.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
